export const GET_COMMUNITY_PROFILE = "GET_COMMUNITY_PROFILE";
export const RESET_COMMUNITY_PROFILE = "RESET_COMMUNITY_PROFILE";
export const START_LOADING_COMMUNITY = "START_LOADING_COMMUNITY";
export const STOP_LOADING_COMMUNITY = "STOP_LOADING_COMMUNITY";
export const ERROR_LOADING_COMMUNITY = "ERROR_LOADING_COMMUNITY";